import { Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    standalone: false
})
export class CheckboxComponent {

	@Input() isChecked: boolean = false;
	@Input() label: string | null = null;
	@Input() amount: number | null = null;
	@Input() isAmountShown: boolean = true;
	@Input() dataTest: string | null = null;
	@Input() size: string = '14px';
	@Input() set colorChecked(color: string | null) {
		color
			? this.checkboxRef.nativeElement.style.setProperty('--color-checked', color)
			: this.checkboxRef.nativeElement.style.removeProperty('--color-checked');
	};
	@Input() set colorUnchecked(color: string | null) {
		color
			? this.checkboxRef.nativeElement.style.setProperty('--color-unchecked', color)
			: this.checkboxRef.nativeElement.style.removeProperty('--color-unchecked');
	};

	@ViewChild('Checkbox', { static: true }) checkboxRef: ElementRef<HTMLDivElement> | undefined;

}
